function domReady(fnc) {
	document.addEventListener("DOMContentLoaded", fnc);
}

domReady(() => {
	document.addEventListener("ds:variant-selected", () => initWarehouseSeparateSelect());
});

function warehouseRadio() {
	const warehouseOptions = document.querySelectorAll(".js-warehouse-option");
	const availableNotification = document.querySelector(
		".js-warehouse-available-notification",
	);

	if (window.customer.currency !== 'USD') return;
	
	for (const option of warehouseOptions) {
		option.addEventListener("click", () => {
			handleWarehouseClick(
				option,
				warehouseOptions,
				availableNotification,
      );
		});
	}
}
domReady(warehouseRadio);

function handleWarehouseClick(target, options, notification) {
  if (target.classList.contains("option-selected")) return;
	// Style update
	for (const option of options) {
		option.classList.remove("option-selected");
		option
			.querySelector(".js-warehouse-radio")
			?.classList.remove("warehouse-selected");
		option.querySelector(".js-warehouse-radio")?.removeAttribute("checked");
	}
	target.classList.add("option-selected");
	target
		.querySelector(".js-warehouse-radio")
		?.classList.add("warehouse-selected");
  target.querySelector(".js-warehouse-radio")?.setAttribute("checked", true);

	// In stock available notification and count update
  const inStockRow = target.querySelector(".js-availability-in-stock");
	if (inStockRow) {
		if (!notification.classList.contains("hidden")) {
			notification.classList.add("hidden");
		}
	} else {
		notification.classList.remove("hidden");
	}
}

function initWarehouseSeparateSelect() {
	// Check if PDP has warehouse separate select
	const warehouseSeparateSelect = document.getElementById("warehouse-location-select-details");

	if (!warehouseSeparateSelect?.parentElement?.classList.contains("warehouse-accordion")) return

  // When warehouse option is selected
  const warehouseOptionContainers = document.querySelectorAll(".warehouse-select-location-options-container");

  // loops over the warehouse ui components
  for (const warehouse of warehouseOptionContainers) {
    warehouse.addEventListener("click", (event) => handleClick(event, warehouse))
  }

	const targetLocation = warehouseSeparateSelect.dataset.selectedWarehouse
	updateWarehouseRelatedDisplay(targetLocation)
}
domReady(initWarehouseSeparateSelect);

function updateWarehouseRelatedDisplay(location) {
	const currentLocation = getCurrentWarehouse(location);

	const warehouseContainer = document.getElementById(
		"warehouse-location-select-details",
	);
	const warehouseData =
		warehouseContainer.dataset.warehouseStoreData.split("?");

	const { regular: matchedVariantData, preorder: matchedPreorderVariantData } =
		findMatchingVariants(warehouseData);

	// Update warehouse selection visibility
	const hasMatchedVariants =
		matchedVariantData !== "" || matchedPreorderVariantData !== "";
	updateWarehouseVisibility(warehouseContainer, hasMatchedVariants);

	// When warehouse selection is displayed
	if (!hasMatchedVariants) return;

	if (matchedVariantData) {
		//Update inventory availability
		updateAvailabilityTables(matchedVariantData, matchedPreorderVariantData);
		updateWarehouseAvailabilityNotification(
			matchedVariantData,
			currentLocation,
		);
		// Update Input max and available values
		updateQuantityAndCartButton(
			matchedVariantData,
			matchedPreorderVariantData,
			currentLocation,
		);
	}
}

const findMatchingVariants = (warehouseData) => {
	const currentOptions = getCurrentVariantOptions();

	if (!currentOptions) return { regular: "", preorder: "" };

	return warehouseData.reduce(
		(matches, variant) => {
			const [options, data] = variant.split("!");
			if (!options) return matches;

			if (isPreorderVariant(options)) {
				return handlePreorderVariant(options, data, currentOptions, matches);
			}
			return handleRegularVariant(options, data, currentOptions, matches);
		},
		{ regular: "", preorder: "" },
	);
};

const updateWarehouseVisibility = (container, hasMatchedVariants) => {
	const parent = container.parentElement;
	const classesToRemove = [
		"warehouse-selection__displayed",
		"warehouse-selection__hidden",
		"hidden",
	];

  for (const className of classesToRemove) {
    parent.classList.remove(className)
  }

	const visibilityClass = hasMatchedVariants
		? "warehouse-selection__displayed"
		: "warehouse-selection__hidden";

	parent.classList.add(visibilityClass);
};

const updateAvailabilityTables = (
	matchedVariantData,
	matchedPreorderVariantData,
) => {
	const tables = document.querySelectorAll(".product__availability-container");

	for (const table of tables) {
		const warehouseLocation = table.dataset.warehouseLocation.toLowerCase();
		table.innerHTML = "";

		const regularRows = getRegularInventoryRows(
			matchedVariantData,
			warehouseLocation,
		);
		const preorderRows = getPreorderInventoryRows(
			matchedPreorderVariantData,
			warehouseLocation,
		);
		const rows = [...regularRows, ...preorderRows];

		if (rows.length === 0) {
			table.innerHTML = createUnavailableRow();
		} else {
			table.innerHTML = rows.join("");
		}
	}
};

const updateWarehouseAvailabilityNotification = (
	matchedVariantData,
	currentLocation,
) => {
	const { notification, notificationText } = updateWarehouseNotification();

	if (!matchedVariantData) return;

	let warehouseList = "";
	const matchedVariantDataArray = matchedVariantData.split(",");
	let currentWarehouseInventoryZero = false;
	let anotherWarehouseInventoryZero = true;
	for (const locationData of matchedVariantDataArray) {
		const [inventory, , location] = locationData.split("|");
		const warehouseLocation = location.toLowerCase();

		if (warehouseLocation === currentLocation) {
			const currentInventory = Number.parseInt(inventory);

			currentWarehouseInventoryZero = currentInventory === 0
		} else {
			const otherInventory = Number.parseInt(inventory);
			if (otherInventory > 0) {
				const capitalizedLocation = `${warehouseLocation.charAt(0).toUpperCase()}${warehouseLocation.slice(1)}`;
				warehouseList += ` or ${capitalizedLocation}`;
				anotherWarehouseInventoryZero = false;
			}
		}

		if (
			notification &&
			currentWarehouseInventoryZero &&
			!anotherWarehouseInventoryZero
		) {
			const message = `Select ${warehouseList.slice(4)} Warehouse to check in-stock inventory`;
			notificationText.innerText = message
			notification.style.display = "block";
		} else {
			notification.style.display = "none";
		}
	}
};

const updateQuantityAndCartButton = (
	matchedVariantData,
	matchedPreorderVariantData,
	currentLocation,
) => {
	const quantityInput = document.querySelector(".quantity__input");
	if (!quantityInput) return;

	const { existInstockQuantity, existPreorderQuantity } =
		getExistingCartQuantities(quantityInput, currentLocation);

	const addToCartTextContainer = document.querySelector(
		".product-form__buttons button span",
	);
	const { inputAvailableValue, inputMaxValue } = calculateInputValues(
		matchedVariantData,
		matchedPreorderVariantData,
		currentLocation,
		existInstockQuantity,
		existPreorderQuantity,
		quantityInput,
	);

	updateCartButtonState(
		addToCartTextContainer,
		inputAvailableValue,
		inputMaxValue,
	);
};

function handleClick(event, warehouse) {
  event.stopPropagation()
  const warehouseContainer = document.getElementById("warehouse-location-select-details")
  const currentLocation = warehouseContainer?.dataset?.selectedWarehouse
  const targetInput = warehouse.querySelector(".warehouse-select-location-options")
  const targetLocation = targetInput?.dataset?.warehouseLocation

  if (currentLocation !== targetLocation) {
      const newLocation = targetLocation
      // Update details dataset
      warehouseContainer.setAttribute("data-selected-warehouse", newLocation)
      // Update related inventory displays and settings
      updateWarehouseRelatedDisplay(targetLocation)

      document.dispatchEvent(
          new CustomEvent("warehouseUpdate", {
              detail: targetLocation,
              bubbles: true,
              composed: true,
          })
      )
  }
}

//////
// Helper Functions
/////

const getCurrentWarehouse = (location) => {
	if (location !== "unset") return location;

	const warehouseContainer = document.getElementById(
		"warehouse-location-select-details",
	);
	return warehouseContainer.dataset.selectedWarehouse;
};

const getCurrentVariantOptions = () => {
	const currentVariantOptions = Array.from(
		document.querySelectorAll("legend.form__label span:not(.option-toggle)"),
	);
	return currentVariantOptions.reduce((accumulator, option) => {
		const optionText = option.textContent.trim();
		return accumulator ? `${accumulator} / ${optionText}` : optionText;
	}, "");
};

const isPreorderVariant = (options) => options.includes(" (Preorder)");

const handlePreorderVariant = (options, data, currentOptions, matches) => {
	const cleanOptions = options.replace(/ \(Preorder\)/g, "");
	if (data && cleanOptions === currentOptions) {
		return { ...matches, preorder: data };
	}
	return matches;
};

const handleRegularVariant = (options, data, currentOptions, matches) => {
	if (data && options === currentOptions) {
		return { ...matches, regular: data };
	}
	return matches;
};

const getRegularInventoryRows = (variantData, targetLocation) => {
	if (!variantData) return [];

	return variantData
		.split(",")
		.map((data) => {
			const [quantity, , location] = data.split("|");
			if (location.toLowerCase() !== targetLocation || quantity === "0")
				return null;
			return `
        <tr class="product__availability-table-row js-availability-in-stock" data-available-count="${quantity}">
          <td class="product__availability-table-cell">${quantity}</td>
          <td class="product__availability-table-cell">In stock</td>
        </tr>
      `;
		})
		.filter(Boolean);
};

const getPreorderInventoryRows = (variantData, targetLocation) => {
	if (!variantData) return [];

	return variantData
		.split(",")
		.map((data) => {
			const [quantity, status, location] = data.split("|");
			if (location.toLowerCase() !== targetLocation) return "";

			return `
                <tr class="product__availability-table-row">
                    <td class="product__availability-table-cell">${quantity}</td>
                    <td class="product__availability-table-cell">${status}</td>
                </tr>
            `;
		})
		.filter(Boolean);
};

const createUnavailableRow = () => `
  <tr class="product__availability-table-row">
  	<td class="product__availability-table-cell">Currently Unavailable</td>
  </tr>
`;

const updateWarehouseNotification = () => {
  const notification = document.querySelector(".js-warehouse-available-notification")
  const notificationText = document.querySelector(".js-warehouse-available-notification-text")

  return { notification, notificationText }
}

const getExistingCartQuantities = (quantityInput, currentLocation) => {
	const cartLineItems = quantityInput.dataset.existCartItems;
	const currentSKU = document
		.querySelector(".product__sku")
		.innerText.replace("SKU: ", "");
	let existInstockQuantity = 0;
	let existPreorderQuantity = 0;

	if (!cartLineItems) return { existInstockQuantity, existPreorderQuantity };

	for (const cartLineItem of cartLineItems.split(",")) {
		const [sku, quantity, warehouse] = cartLineItem.split("|");

		if (sku.includes(currentSKU) && warehouse === currentLocation) {
			const cartLineItemQuantity = Number.parseInt(quantity);
			if (sku.includes("PRE-")) {
				existPreorderQuantity += cartLineItemQuantity;
			} else {
				existInstockQuantity += cartLineItemQuantity;
			}
		}
	}

	return { existInstockQuantity, existPreorderQuantity };
};

const calculateInputValues = (
	matchedVariantData,
	matchedPreorderVariantData,
	currentLocation,
	existInstockQuantity,
	existPreorderQuantity,
	quantityInput,
) => {
	let inputAvailableValue = 0;
	let inputMaxValue = 0;

	if (matchedVariantData) {
		for (const locationData of matchedVariantData.split(",")) {
			const [quantity, , warehouse] = locationData.split("|");
			if (warehouse.toLowerCase() === currentLocation) {
				inputAvailableValue = Number.parseInt(quantity);
			}
			inputAvailableValue -= existInstockQuantity;
			inputAvailableValue = Math.max(0, inputAvailableValue);
		}
		quantityInput.setAttribute("data-available-qty", inputAvailableValue);
	}

	if (matchedPreorderVariantData) {
		for (const locationData of matchedPreorderVariantData.split(",")) {
			const [quantity, , warehouse] = locationData.split("|");
			if (warehouse.toLowerCase() === currentLocation) {
				inputMaxValue += Number.parseInt(quantity);
			}
		}
	}

	inputMaxValue += inputAvailableValue;
	inputMaxValue -= existPreorderQuantity;
	inputMaxValue = Math.max(0, inputMaxValue);
	quantityInput.setAttribute("max", inputMaxValue);

	return { inputAvailableValue, inputMaxValue };
};

const updateCartButtonState = (button, availableValue, maxValue) => {
	if (!button) return;

	const parent = button.parentElement;

	if (availableValue === 0 && maxValue > 0) {
		button.innerText = "Preorder";
		parent.removeAttribute("disabled");
	} else if (availableValue > 0) {
		button.innerText = "Add To Cart";
		parent.removeAttribute("disabled");
	} else if (availableValue === 0 && maxValue === 0) {
		button.innerText = "Sold Out";
		parent.setAttribute("disabled", "disabled");
	}
};
